<!-- =========================================================================================
  File Name: UserEditTabInformation.vue
  Description: User Edit Information Tab content
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
	<div id="user-edit-tab-info">
		<div class="vx-row mb-2">
			<div class="vx-col w-full flex items-center">
				<feather-icon
					class="g-breadcrumb--title"
					icon="ChevronLeftIcon"
					svgClasses="h-8 w-8"
					@click.prevent="$router.push({name: 'app-visit-point-list'})"
				/>
				<vs-breadcrumb
					class="g-breadcrumb--title"
					separator=""
					:items="[{title: $t('general.Return')}]"
					@click.prevent="$router.push({name: 'app-visit-point-list'})"
				></vs-breadcrumb>
			</div>
		</div>
		<vs-row vs-w="12">
			<vs-col
				:vs-lg="windowWidth < 1366 ? '12' : '5'"
				:vs-sm="windowWidth < 1366 ? '12' : '5'"
				vs-xs="12"
				class="pr-2"
			>
				<vx-card v-show="windowWidth > 1280 || maximize">
					<template slot="actions">
						<feather-icon
							v-show="maximize && windowWidth < 1280"
							icon="XSquareIcon"
							svgClasses="h-5 w-5"
							class="hover:text-success"
							@click.stop="maximize = !maximize"
						/>
					</template>
					<div class="vx-row">
						<div class="vx-col md:w-1/2 w-full">
							<label class="g-label" v-text="$t('MapModule.Latitude')"></label>
							<vs-input class="w-full mb-4" v-model="visitPoint.cy" name="cy" disabled />
							<span
								class="text-danger text-sm"
								v-show="errors.has('cy')"
								v-text="errors.first('cy')"
							></span>
						</div>
						<div class="vx-col md:w-1/2 w-full">
							<label class="g-label" v-text="$t('MapModule.Longitude')"></label>
							<vs-input class="w-full mb-4" v-model="visitPoint.cx" name="cx" disabled />
							<span
								class="text-danger text-sm"
								v-show="errors.has('cx')"
								v-text="errors.first('cx')"
							></span>
						</div>
					</div>
					<div class="map-custom-container">
						<here-map
							name="theMap"
							ref="moduleMap"
							latitude="4.686699"
							longitude="-74.0837187"
							zoom="13"
							:width="widthMap"
							height="90vh"
							theme="uber"
							calledFrom="calendar"
							@geoInversoEmit="geoInverso"
						></here-map>
					</div>
				</vx-card>
			</vs-col>
			<vs-col
				class="pr-2"
				vs-justify="center"
				vs-align="center"
				:vs-lg="windowWidth < 1366 ? '12' : '7'"
				:vs-sm="windowWidth < 1366 ? '12' : '7'"
				vs-xs="12"
			>
				<vx-card v-show="windowWidth > 1280 || !maximize" style="height: 100%">
					<template slot="actions">
						<feather-icon
							v-show="windowWidth <= 1280"
							icon="MapIcon"
							svgClasses="h-5 w-5"
							class="hover:text-success"
							@click.stop="maximize = !maximize"
						/>
					</template>
					<vs-navbar :type="'gradient'" v-model="activeNavItem" class="nabarx mb-5">
						<div slot="title">
							<vs-navbar-title>
								<span class="g-tools--description">{{ navbarTitle }}</span>
							</vs-navbar-title>
						</div>
						<vs-navbar-item :index="0">
							<a>
								<div class="flex flex-col items-center justify-center">
									<vx-tooltip
										style="z-index: 99999"
										:title="$t('Information')"
										color="primary"
										position="bottom"
										:text="`${$t('Information')}: ${$t('Resource.PrincipalProperties')}, ${$t(
											'Resource.AdditionalProperties'
										)}`"
									>
										<vs-icon icon="info" size="medium" class="cursor-pointer"></vs-icon>
									</vx-tooltip>
									<small>{{ $t("Information") }}</small>
								</div>
							</a>
						</vs-navbar-item>
						<vs-navbar-item :index="1" v-if="visitpointRelationship !== 'all'">
							<a>
								<div class="flex flex-col items-center justify-center">
									<vs-icon icon="person" size="medium" class="cursor-pointer"></vs-icon>

									<small>{{ $t("Resource.AssigResources") }}</small>
								</div>
							</a>
						</vs-navbar-item>
						<vs-spacer></vs-spacer>
					</vs-navbar>
					<transition name="fade">
						<div v-show="activeNavItem === 0">
							<!-- STATICS FIELDS -->
							<!-- ROW ONE -->
							<div class="vx-row">
								<!--NAME -->
								<div class="vx-col md:w-1/2 w-full">
									<label class="g-label" v-text="$t('Name')"></label>
									<vs-input
										class="w-full"
										v-model="visitPoint.name"
										v-validate="'required'"
										name="name"
									/>
									<span
										class="text-danger text-sm"
										v-show="errors.has('name')"
										v-text="$t('VisitPointObject.Edit.ValidMessages.Name')"
									></span>
								</div>
								<!--IDENTIFICATION -->
								<div class="vx-col md:w-1/2 w-full">
									<label class="g-label" v-text="$t('Identification')"></label>
									<vs-input
										class="w-full"
										v-model="visitPoint.identification"
										type="identification"
										v-validate="'required|alpha_num'"
										name="identification"
									/>
									<span
										class="text-danger text-sm"
										v-show="errors.has('identification')"
										v-text="$t('VisitPointObject.Edit.ValidMessages.Identification')"
									></span>
								</div>
							</div>
							<!-- ROW TWO -->
							<div class="vx-row mt-4">
								<div class="vx-col md:w-1/2 w-full">
									<!-- PHONE -->
									<label class="g-label" v-text="$t('Phone')"></label>
									<vs-input
										class="w-full"
										v-model="visitPoint.phone"
										v-validate="'required'"
										name="phone"
									/>
									<span
										class="text-danger text-sm"
										v-show="errors.has('phone')"
										v-text="$t('VisitPointObject.Edit.ValidMessages.Phone')"
									></span>
								</div>
								<div class="vx-col md:w-1/2 w-full">
									<!--ADDRESS -->
									<label class="g-label" v-text="$t('Address')"></label>
									<vs-input
										class="w-full"
										v-model="visitPoint.address"
										@change="showGeoAgaing = true"
										v-validate="'required'"
										name="address"
									/>
									<span
										class="text-danger text-sm"
										v-show="errors.has('address')"
										v-text="$t('VisitPointObject.Edit.ValidMessages.Address')"
									></span>
								</div>
							</div>
							<div class="vx-row mt-4">
								<!-- COUNTRY -->
								<div class="vx-col md:w-1/2 w-full">
									<label class="g-label" v-text="$t('Country')"></label>
									<v-select
										v-model="selectedCountry"
										name="country"
										v-validate="'required'"
										:clearable="false"
										:options="countriesOptions"
										:dir="$vs.rtl ? 'rtl' : 'ltr'"
										:disabled="
											visitPoint.address === '' ||
											visitPoint.address === null ||
											visitPoint.address === undefined
										"
									>
										<template v-slot:no-options="{search, searching}">
											<template v-if="searching">
												{{ $t("general.NoResultsFoundFor") + " " }}<em>{{ search }}</em>
											</template>
										</template>
									</v-select>
									<span
										class="text-danger text-sm"
										v-show="errors.has('country')"
										v-text="$t('VisitPointObject.Edit.ValidMessages.Country')"
									></span>
								</div>
								<div class="vx-col md:w-1/2 w-full">
									<!--Department -->
									<label class="g-label">{{ getPoliticalDivision.department }}</label>
									<v-select
										v-model="dpto_local_sel"
										name="departments"
										v-validate="'required'"
										:clearable="false"
										:options="departments"
										:dir="$vs.rtl ? 'rtl' : 'ltr'"
										:loading="departments.length <= 0 && selectedCountry ? true : false"
										:disabled="
											departments.length <= 0 ||
											visitPoint.address === '' ||
											visitPoint.address === null ||
											visitPoint.address === undefined
										"
									>
										<template v-slot:no-options="{search, searching}">
											<template v-if="searching">
												{{ $t("general.NoResultsFoundFor") + " " }}<em>{{ search }}</em>
											</template>
										</template>
									</v-select>
									<span class="text-danger text-sm" v-show="errors.has('departments')">{{
										$t("ValidateField", {n: getPoliticalDivision.department.toLowerCase()})
									}}</span>
								</div>
							</div>
							<!-- ROW THREE -->
							<div class="vx-row mt-4">
								<div class="vx-col md:w-1/2 w-full">
									<!--CITY -->
									<label class="g-label">{{ getPoliticalDivision.city }}</label>
									<v-select
										v-model="city_local_sel"
										name="cities"
										v-validate="'required'"
										:clearable="false"
										:options="cities"
										:dir="$vs.rtl ? 'rtl' : 'ltr'"
										:loading="
											cities.length <= 0 && dpto_local_sel && selectedCountry ? true : false
										"
										:disabled="
											cities.length <= 0 ||
											visitPoint.address === '' ||
											visitPoint.address === null ||
											visitPoint.address === undefined
										"
									>
										<template v-slot:no-options="{search, searching}">
											<template v-if="searching">
												{{ $t("general.NoResultsFoundFor") + " " }}<em>{{ search }}</em>
											</template>
										</template>
									</v-select>
									<span class="text-danger text-sm" v-show="errors.has('cities')">{{
										$t("ValidateField", {n: getPoliticalDivision.city.toLowerCase()})
									}}</span>
								</div>
								<div class="vx-col md:w-1/2 w-full">
									<label class="g-label">{{ $t("Status") }}</label>
									<v-select
										v-model="status_local_sel"
										:clearable="false"
										:options="statusOptions"
										v-validate="'required'"
										name="status"
									>
										<template v-slot:no-options="{search, searching}">
											<template v-if="searching">
												{{ $t("general.NoResultsFoundFor") + " " }}<em>{{ search }}</em>
											</template>
										</template>
									</v-select>
									<span
										class="text-danger text-sm"
										v-show="errors.has('status')"
										v-text="$t('VisitPointObject.Edit.ValidMessages.Status')"
									></span>
								</div>
							</div>
							<div class="vx-row mt-4 mb-4">
								<div class="vx-col w-full">
									<vs-button
										:disabled="!showGeoAgaing"
										class="w-full g-btn--resourcePopup mb-2"
										type="filled"
										color="primary"
										@click="geoCoder"
										>{{ $t("MapModule.GeoAgain") }}
									</vs-button>
								</div>
							</div>
							<!-- DINAMIC FIELDS -->
							<vs-divider></vs-divider>
							<p class="g-object--description">
								{{ $t("Object.AdditionalFields") }}
							</p>
							<dinamic-fields
								ref="DinamicFields"
								v-if="dataFields && dataFields.length > 0"
								:additionalFields="dataFields"
								:additionalInfo="additional_info"
								:category="selectedT"
							></dinamic-fields>
						</div>
					</transition>
					<transition name="fade">
						<vs-row vs-w="12" v-show="activeNavItem === 1">
							<vs-col vs-justify="center" vs-align="center" vs-lg="12" vs-sm="12" vs-xs="12">
								<vs-alert
									:active.sync="activeAllocationByZones"
									color="warning"
									icon-pack="feather"
									icon="icon-alert-triangle"
									class="mb-4"
								>
									{{ $t("VisitPointObject.AssignedResourceByZonesTextAlert") }}
								</vs-alert>
								<resource-list
									v-if="visitpointUpdatePermission"
									class="mt-4"
									:relatedIds="visitPoint.resource_id"
									:customConfig="{activeCheckbox: false}"
								></resource-list>
							</vs-col>
						</vs-row>
					</transition>
				</vx-card>
			</vs-col>
		</vs-row>
		<vs-row vs-w="12">
			<vs-col vs-lg="12" vs-sm="12" vs-xs="12">
				<!-- Save & Reset Button  :disabled="!validateForm"-->
				<div class="vx-row mt-4">
					<div class="vx-col w-full">
						<div class="flex flex-wrap items-center justify-end">
							<vs-button
								class="mr-2 g-btn--resourcePopup"
								type="filled"
								color="#FF4B55"
								:to="{name: 'app-visit-point-list'}"
								>{{ $t("Cancel") }}
							</vs-button>
							<vs-button
								id="btn-update-visit-point"
								class="mr-2 vs-con-loading__container g-btn--resourcePopup"
								color="success"
								:disabled="!validateForm"
								@click.prevent="updateVisitPoint"
								>{{ $t("Save") }}
							</vs-button>
						</div>
					</div>
				</div>
			</vs-col>
		</vs-row>
		<vs-prompt title="" @cancel="close" @accept="acceptAlert" @close="close" :active.sync="activePrompt">
			<div class="con-exemple-prompt">
				<p>
					{{ $t("VisitPointObject.Create.GeoFindNextAddress") }}
				</p>
				<vs-input
					placeholder="Code"
					vs-placeholder="Code"
					v-model="dataGeo.address1"
					class="mt-3 w-full mb-4"
				/>
				<p>{{ $t("VisitPointObject.Create.UseAddressQuestion") }}</p>
			</div>
		</vs-prompt>
	</div>
</template>

<script>
import vSelect from "vue-select";
import HereMap from "@/components/Maps/Maps.vue";
import VisitPoint from "@/models/VisitPoint.js";
import moduleResource from "@/store/resource/moduleResource.js";
import Commons from "@/helpers/commons.js";
import moduleVisitPoint from "@/store/visit-point/moduleVisitPoint.js";
import moduleCommon from "@/store/common/moduleCommon.js";
import {clearMap} from "../../../utils/HereMap";
import DinamicFields from "@/components/DinamicFields/DinamicFields";
import ManageErrorMessages from "@/models/ManageErrorMessages";
import ResourceList from "@/components/resource/resource-assigned-list/ResourceList";
import {politicalDivisionMixin} from "@/mixins/politicalDivisionMixin.js";

export default {
	mixins: [politicalDivisionMixin],
	props: {
		data: {
			type: Object,
			required: true,
		},
	},
	data() {
		return {
			dataRoleStateTipology: null,
			visitPoint: JSON.parse(JSON.stringify(this.data)),
			selectedCity: null,
			selectedDepartment: null,
			departments: [],
			countries: [],
			cities: [],
			dataGeo: {
				address1: "",
				city1: "",
				commune1: "",
				dane1: "",
				department1: "",
				neighborhood1: "",
				status: "",
			},
			activePrompt: false,
			val: "",
			showGeoAgaing: false,
			selectedT: null,
			additional_info: {},
			manageErrorMessages: new ManageErrorMessages({that: this}),
			activeNavItem: 0,
			activeAllocationByZones: false,
			maximize: false,
		};
	},
	components: {
		ResourceList,
		DinamicFields,
		HereMap,
		vSelect,
	},
	computed: {
		navbarTitle() {
			if (this.activeNavItem === 0) return this.$t("Information");
			else return this.$t("Resource.AssigResources");
		},
		windowWidth() {
			return this.$store.state.windowWidth;
		},
		widthMap() {
			let widthValue = "";
			if (this.windowWidth >= 1366 && this.windowWidth < 1920) {
				widthValue = "100%";
			} else if (this.windowWidth >= 600 && this.windowWidth < 1366) {
				widthValue = "100%";
			} else if (this.$store.state.reduceButton && this.windowWidth > 600) {
				widthValue = "33vw";
			} else if (this.windowWidth > 600) {
				widthValue = "27vw";
			} else if (this.windowWidth < 600) {
				widthValue = "100%";
			}
			return widthValue;
		},
		countriesOptions() {
			return this.generateOptionSelect(
				this.$store.state.moduleCommon.countries_sitidata,
				"country_name",
				"country_name"
			);
		},
		validateForm() {
			return !this.errors.any();
		},
		statusOptions() {
			if (!this.dataRoleStateTipology) {
				return [];
			}
			const {status} = this.dataRoleStateTipology;
			return status.map((status) => {
				return {label: status.name, value: status.id};
			});
		},
		dataFields() {
			if (this.dataRoleStateTipology) {
				const found = this.dataRoleStateTipology.category.find(
					(category) => category.typology_id === this.visitPoint.typology_id
				);
				this.selectedT = found;
				return new VisitPoint({}).dataModelDinamicFields(found);
			} else {
				return [];
			}
		},
		status_local_sel: {
			get() {
				const found = this.statusOptions.find((status) => status.value === this.visitPoint.status_id);
				return {
					label: found === undefined ? "" : found.label,
					value: found === undefined ? "" : found.value,
				};
			},
			set(obj) {
				this.visitPoint.status_id = obj.value;
			},
		},
		selectedCountry: {
			get() {
				if (this.visitPoint.country !== undefined) this.getDepartments(this.visitPoint.country);
				return {
					label: this.visitPoint.country === undefined ? "" : this.visitPoint.country,
					value: this.visitPoint.country === undefined ? "" : this.visitPoint.country,
				};
			},
			set(obj) {
				this.dpto_local_sel = {};
				this.city_local_sel = {};
				this.visitPoint.country = obj.value;
			},
		},
		city_local_sel: {
			get() {
				return {
					label: this.visitPoint.city,
					value: this.visitPoint.city,
				};
			},
			set(obj) {
				this.visitPoint.city = obj.value;
			},
		},
		dpto_local_sel: {
			get() {
				if (this.visitPoint.department) this.getCities(this.visitPoint.department);
				return {
					label: this.visitPoint.department,
					value: this.visitPoint.department,
				};
			},
			set(obj) {
				this.city_local_sel = {};
				this.visitPoint.department = obj.value;
			},
		},
		visitpointRelationship() {
			const visitpointConfig = this.$store.getters["moduleCompanyConfig/visitpointConfig"];
			if (visitpointConfig) {
				return visitpointConfig.config_json.relationship;
			} else {
				return "all";
			}
		},
		visitpointUpdatePermission() {
			return this.$store.getters.checkPermission("VISIT_POINT_U");
		},
	},
	methods: {
		/** generate data for any select */
		generateOptionSelect(data, propLabel, propValue) {
			if (!Array.isArray(data)) {
				return [];
			}
			return data.map((d) => {
				return {label: d[propLabel], value: d[propValue]};
			});
		},
		fetchDataSelect() {
			const payload = {
				role: [1, 2, 3, 4, 5],
				status: [],
				category: "VISIT_POINT",
				typology: [],
			};
			this.$store
				.dispatch("moduleResource/fetchDataSelect", payload)
				.then((res) => {
					this.dataRoleStateTipology = res.data;
					setTimeout(() => {
						if (this.$refs.moduleMap) this.$refs.moduleMap.addMarkerVisitPoint(this.visitPoint);
					}, 1000);
				})
				.catch((error) => {
					throw new Error(error);
				});
		},
		openLoading() {
			this.$vs.loading();
		},
		closeLoading() {
			this.$vs.loading.close();
		},
		updateVisitPoint() {
			const ids = this.$store.state.moduleResource.resourcesActivity.map(({id}) => id);
			this.visitPoint["resource_id"] = ids || [];
			if (this.$refs.DinamicFields !== undefined) {
				if (Object.values(this.visitPoint.additional_info).length > 0) {
					const additional_info = this.$refs.DinamicFields.getAddionalInfo();
					this.visitPoint.additional_info = additional_info;
				}
			}
			Commons.openLoadingButton.call(this, "btn-update-visit-point");
			this.$store
				.dispatch("moduleVisitPoint/updateVisitPoint", this.visitPoint)
				.then((res) => {
					this.showDeleteSuccess();
					Commons.closeLoadingButton.call(this, "btn-update-visit-point");
					this.$router.push({name: "app-visit-point-list"});
				})
				.catch((err) => {
					Commons.closeLoadingButton.call(this, "btn-update-visit-point");
					this.manageErrorAlert(err);
					throw new Error(err);
				});
		},
		manageErrorAlert(err) {
			const {title, text} = Commons.manageErrorValidator.call(this, err);
			const findErrorNameProperty = Commons.findErrorNamePropertyValidator();
			const nameProperty = findErrorNameProperty(err);
			const alert_message = `${this.$t("ManualData.PropertyError")} ${nameProperty}: ${
				text ? text : this.$t("ManualData.ValidatorRequiredProperty")
			}`;
			this.$vs.notify({
				color: "danger",
				title,
				text: alert_message,
				time: 6000,
			});
		},
		showDeleteSuccess() {
			this.$vs.notify({
				color: "success",
				title: this.$t("VisitPointObject.Edit.Success.Title"),
				text: this.$t("VisitPointObject.Edit.Success.Text"),
			});
		},
		geoInverso({country, cy, cx}) {
			this.openLoading();
			this.$store
				.dispatch("moduleMap/geoinverso", {country, cy, cx})
				.then((res) => {
					this.closeLoading();
					this.dataGeo = {...res.data};
					this.dataGeo.longitude = parseFloat(cx);
					this.dataGeo.latitude = parseFloat(cy);
					if (res.data.address1 !== this.visitPoint.address) {
						this.activePrompt = true;
					}
					if (res.status === 200 && res.data.status === "C") {
						this.activePrompt = false;
						this.$vs.notify({
							color: "warning",
							title: this.$t("VisitPointObject.Create.ErrorFindAddress.Title"),
							text:
								this.$t("VisitPointObject.Create.ErrorFindAddress.Text") +
								", " +
								this.$t("VisitPointObject.Create.ErrorFindCountry.Text"),
							time: 7000,
						});
					}
				})
				.catch((err) => {
					this.closeLoading();
					this.manageErrorMessages.processError(err);
					throw new Error(err);
				});
		},
		geoCoder() {
			const {country, city, address, department} = this.visitPoint;
			if (address === null || address === undefined || address === "") {
				this.$vs.notify({
					color: "warning",
					title: this.$t("VisitPointObject.Create.MissingAddress.Title"),
					text: this.$t("VisitPointObject.Create.MissingAddress.Text"),
				});
				return;
			}
			this.openLoading();
			this.$store
				.dispatch("moduleMap/geocoder", {country, city, address, department})
				.then((res) => {
					this.closeLoading();
					if (res.status !== 200) {
						throw new Error("Not georreferencer address");
					}
					if (res.status === 200 && res.message === "Procesado y no ubicado.") {
						this.activePrompt = false;
						this.$vs.notify({
							color: "warning",
							title: this.$t("MapModule.Georeferencer"),
							text: this.$t("ManualData.AddressCouldBeNotGeoreferenced"),
						});
						return;
					}

					if (res.status === 200 && res.message === "Geocodificacion Exitosa.") {
						clearMap();
						this.dataGeo = {...res.data};
						this.visitPoint.cy = parseFloat(this.dataGeo.latitude).toFixed(8);
						this.visitPoint.cx = parseFloat(this.dataGeo.longitude).toFixed(8);
						if (this.dataGeo.latitude !== "0" || this.dataGeo.longitude !== "0") {
							this.$vs.notify({
								color: "sucess",
								title: this.$t("VisitPointObject.Create.FindAddress.Title"),
								text: this.$t("VisitPointObject.Create.FindAddress.Text"),
							});
							this.showGeoAgaing = false;
							this.$refs.moduleMap.addMarkerVisitPoint(this.visitPoint);
						} else {
							this.$vs.notify({
								color: "warning",
								title: this.$t("VisitPointObject.Create.ErrorFindAddress.Title"),
								text: this.$t("VisitPointObject.Create.ErrorFindAddress.Text"),
							});
						}
					}
				})
				.catch((err) => {
					this.closeLoading();
					this.manageErrorMessages.processError(err);
					throw new Error(err);
				});
		},
		// Not used
		openConfirmDirection(res) {
			this.$vs.dialog({
				type: "confirm",
				color: "success",
				title: "",
				text: `Mensaje de confirmacion`,
				accept: this.acceptAlert,
				acceptText: this.$t("Accept"),
				cancelText: this.$t("Cancel"),
			});
		},
		acceptAlert() {
			this.selectedCountry.label = this.dataGeo.country_long_name;
			this.visitPoint.country = this.dataGeo.country_long_name;
			this.visitPoint.address = this.dataGeo.address1;
			this.dpto_local_sel = {label: this.dataGeo.department1, value: this.dataGeo.department1};
			this.city_local_sel = {label: this.dataGeo.city1, value: this.dataGeo.city1};
			this.visitPoint.department = this.dataGeo.department1;
			this.visitPoint.city = this.dataGeo.city1;
			this.visitPoint.cx = this.dataGeo.longitude.toFixed(8);
			this.visitPoint.cy = this.dataGeo.latitude.toFixed(8);
		},
		close() {
			this.dataGeo.address1 = "";
			this.geoCoder();
		},
		getCities(departmentName) {
			this.$store
				.dispatch("moduleCommon/getCitiesByDeparment", {
					name: departmentName ? departmentName.replaceAll(",", "") : "",
					country: this.visitPoint.country,
				})
				.then((res) => {
					this.cities = this.generateOptionSelect(res.data, "city_name", "city_name");
				})
				.catch((error) => {
					throw new Error(error);
				});
		},
		getDepartments(countryName) {
			this.$store
				.dispatch("moduleCommon/getDepartments", {name: countryName})
				.then((res) => {
					this.departments = this.generateOptionSelect(res.data, "department_name", "department_name");
				})
				.catch((error) => {
					throw new Error(error);
				});
		},
		visitPointAllocationByZonesConfig() {
			const visitpointConfig = this.$store.getters["moduleCompanyConfig/visitpointConfig"];
			if (visitpointConfig) {
				return visitpointConfig.config_json.allocation_by_zones;
			} else {
				return false;
			}
		},
	},
	watch: {
		status_local_sel(object) {
			this.visitPoint.status_id = object.value;
		},
		selectedCity(object) {
			this.visitPoint.city = object.label;
		},
		selectedCountry(object) {
			this.visitPoint.country = object.label;
		},
		selectedDepartment(object) {
			this.visitPoint.department = object.value;
			this.getCities(object.value);
		},
		activeNavItem(val) {
			if (val === 0) {
				setTimeout(() => {
					this.$refs.moduleMap.addMarkerVisitPoint(this.visitPoint);
				}, 1000);
			} else {
				if (this.visitPointAllocationByZonesConfig()) {
					this.activeAllocationByZones = true;
				}
			}
		},
	},
	created() {
		if (!moduleResource.isRegistered) {
			this.$store.registerModule("moduleResource", moduleResource);
			moduleResource.isRegistered = true;
		}
		if (!moduleVisitPoint.isRegistered) {
			this.$store.registerModule("moduleVisitPoint", moduleVisitPoint);
			moduleVisitPoint.isRegistered = true;
		}
		if (!moduleCommon.isRegistered) {
			this.$store.registerModule("moduleCommon", moduleCommon);
			moduleCommon.isRegistered = true;
		}
		if (this.$store.state.moduleCommon.countries_sitidata.length <= 0) {
			this.$store.dispatch("moduleCommon/getCountriesByTokenSitiData").catch((error) => {
				throw new Error(error);
			});
		}
	},
	mounted() {
		this.fetchDataSelect();
	},
};
</script>
<style lang="scss" scoped>
.vs-navbar-gradient .vs-navbar-item-primary.is-active-item {
	border-radius: 6px;
	color: #fff;
	background: rgba(var(--vs-primary), 1);
}

.vs-navbar {
	-webkit-box-shadow: none;
	box-shadow: none;
}

.vs-navbar-gradient {
	border: 1px solid rgba(0, 0, 0, 0.05);
}

.vs-navbar-gradient .vs-navbar--item {
	border-left: 1px solid rgba(0, 0, 0, 0.05);
}
</style>
